import { useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useQueryClient } from 'react-query';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, IconButton, Avatar } from '@mui/material';
// i18n
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
// components
import { useKeycloak } from '@react-keycloak/web';
import MenuPopover from '../../components/MenuPopover';
// mocks_
//
import { stopRefresh } from '../../utils/refreshToken';
// store
import { userStore } from '../../store/userStore';
import { usePermission } from '../../store/usePermission';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(null);
  const [user, setUser] = useState(null);
  // const [user, setAccountCache] = useState(null);
  const { keycloak } = useKeycloak();



  const { t } = useTranslation();
  const setUserNull = userStore((state) => state.setUserNull);
  const setPremissionNull = usePermission((state) => state.setPermissionsNull);
  const queryClient = useQueryClient();

  useEffect(() => {
    let active = true;

    const loadUser = async () => {
      try {
        const profile = await keycloak.loadUserInfo();
        if (active) {
          setUser({
            usuarionome: profile.name || profile.preferred_username,
            usuarioemail: profile.email,
            iconpath: profile.iconpath,
          });
        }
      } catch (error) {
        if (active) {
          const claims = keycloak.tokenParsed || {};
          setUser({
            usuarionome: claims.name || claims.preferred_username,
            usuarioemail: claims.email,
            iconpath: claims.iconpath,
          });
        }
      }
    };

    if (keycloak.authenticated) {
      loadUser();
    }

    return () => {
      active = false;
    };
  }, [keycloak]);

  const MENU_OPTIONS = [
    {
      label: i18next.t('profile-menu.start'),
      icon: 'eva:home-fill',
      linkTo: '/',
    },
    {
      label: i18next.t('profile-menu.profile'),
      icon: 'eva:person-fill',
      onClick: () => keycloak.accountManagement(),
    },
  ];
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const handleLogout = () => {
    const themebackup = localStorage.getItem('darkMode');
    const languagebackup = localStorage.getItem('i18nextLng');
    setUserNull();
    setPremissionNull();
    queryClient.clear();
    localStorage.clear();
    localStorage.setItem('darkMode', themebackup);
    localStorage.setItem('i18nextLng', languagebackup);
    stopRefresh();
    try {
      keycloak.logout({ redirectUri: window.location.origin });

    } catch (e) {
      console.log(e)
    }

  };

  return (
    <>
      <>
        <IconButton
          ref={anchorRef}
          onClick={handleOpen}
          sx={{
            p: 0,
            ...(open && {
              '&:before': {
                zIndex: 1,
                content: "''",
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                position: 'absolute',
                bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
              },
            }),
          }}
        >
          <Avatar src={user?.iconpath || ''} alt={user?.usuarionome} />
        </IconButton>

        <MenuPopover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleClose}
          sx={{
            p: 0,
            mt: 1.5,
            ml: 0.75,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          }}
        >
          <Box sx={{ my: 1.5, px: 2.5 }}>
            <Typography variant="subtitle2" noWrap>
              {user?.usuarionome}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
              {user?.usuarioemail}
            </Typography>
          </Box>

          <Divider sx={{ borderStyle: 'dashed' }} />

          <Stack sx={{ p: 1 }}>
            {MENU_OPTIONS.map((option) => (
              <MenuItem
                key={option.label}
                {...(option.linkTo ? { to: option.linkTo, component: RouterLink } : {})}
                onClick={() => {
                  handleClose();
                  option.onClick?.();
                }}
              >
                {option.label}
              </MenuItem>
            ))}
          </Stack>

          <Divider sx={{ borderStyle: 'dashed' }} />

          <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
            {t('profile-menu.exit')}
          </MenuItem>
        </MenuPopover>
      </>
    </>
  );
}
